export const LANGUAGES = {
  ENG: 'en',
  DEU: 'de',
  ITA: 'it',
  ESP: 'es',
  RUS: 'ru',
} as const;

export const DISPLAYED_LANGUAGES: Record<TLanguagesKeys, Exclude<TLanguagesKeys, 'RUS'> | 'РУС'> = {
  ENG: 'ENG',
  DEU: 'DEU',
  ITA: 'ITA',
  ESP: 'ESP',
  RUS: 'РУС',
};

export type TLanguagesKeys = keyof typeof LANGUAGES;
export type TLanguages = (typeof LANGUAGES)[keyof typeof LANGUAGES];

export interface LanguageContextType {
  language: TLanguages;
  changeLanguage: (lng: TLanguages) => void;
}
